import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-4677RM3JT7";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", GA_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}